import React from "react"

import Flex from "@irati/ui/src/Flex"
import noData from "@irati/ui/images/noData.png"
import {H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

const EmptyData: React.FC = () => {
  return (
    <Flex alignItems="center">
      <img src={noData} alt="noData" />
      <H3 marginLeft={3}>
        <FormattedMessage id="admin.reporting.popularPerks.noData" />
      </H3>
    </Flex>
  )
}

export default EmptyData
